import { jsx as O } from "react/jsx-runtime";
import { forwardRef as M } from "react";
import R from "clsx";
import t from "./flex.module.css.js";
const A = M(function({
  align: a,
  alignContent: c,
  as: i,
  center: e = !1,
  className: p,
  direction: f = "row",
  fill: m,
  gap: $ = "md",
  inline: x,
  justify: g,
  layout: u = {},
  wrap: w = "wrap",
  ...j
}, y) {
  const b = i || "div", d = n($).flatMap(([r, s]) => {
    const [l, N = l] = s.trim().split(" ");
    return [
      t[`${r}-row-gap-${l}`],
      t[`${r}-col-gap-${N}`]
    ];
  }), F = n(u).map(
    ([r, s]) => t[`${r}-${Number(`${s}`.replace("auto", "0"))}`]
    // Convert to number to convert 2.10 to 2.1 and false to 0
  );
  return /* @__PURE__ */ O(
    b,
    {
      ...j,
      className: R(
        t.flex,
        !m || t.fill,
        !x || t.inline,
        t[f],
        t[`align-${a}`],
        t[`align-content-${c}`],
        t[`center-${e === !0 ? "xxl" : e}`],
        t[`justify-${g}`],
        t[`wrap-${w}`],
        ...d,
        ...F,
        p
      ),
      ref: y
    }
  );
}), n = (o) => Object.entries(typeof o == "object" ? o : { xs: o });
export {
  A as Flex
};
//# sourceMappingURL=flex.js.map
